import { useTranslation } from 'react-i18next';
import { DashboardSummary } from '@/components/dashboard/DashboardSummary';
import { usePageMetadata } from '@/hooks/usePageMetadata';
import { Paper, Typography, Box } from '@gapartners/ui';

export function PerformanceView() {
  const { t } = useTranslation();
  // Set page metadata
  usePageMetadata({
    title: t('pages.manager.performance.title'),
    description: t('pages.manager.performance.description'),
  });

  return (
    <Paper variant="outlined" sx={{ p: { xs: 2, sm: 3 } }}>
      <Typography
        variant="h6"
        fontWeight={700}
        color="text.primary"
        gutterBottom
      >
        {t('pages.manager.performance.title')}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t('pages.manager.performance.description')}
      </Typography>
      {/* Dashboard Overview */}
      <Box sx={{ mt: 3, mb: 3 }}>
        <DashboardSummary />
      </Box>
    </Paper>
  );
}
